import { render, staticRenderFns } from "./PremiumList.vue?vue&type=template&id=84244828&"
import script from "./PremiumList.vue?vue&type=script&lang=js&"
export * from "./PremiumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports